<template>
    <div class='crumb-content'>
        <div class="content">
            <div class="left">
                <img src="../assets/address.png" alt="">
                <ul>
                    <li>
                    <router-link to="/">Home -></router-link>
                    </li>
                    <li v-for="(item,index) of crumbOption" :key="index">
                    <router-link :to="`/${item}`">{{item}} {{index != crumbOption.length-1?'->':''}}</router-link>
                    </li>
                </ul>
            </div>
            <div class="right">
                <span class="color1"> Extracted code：</span><span class="color2">{{code}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import state from '../api/store'

export default {
    components: {},
    props:['code'],
    data() {
        return {
        };
    },
    computed: {
      crumbOption(){
          return state.crumb
      },  
    },
    watch: {
          $route(to,from){
               console.log(state);
               this.crumbOption = state.crumb;
            }

    },
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
         //设置面包屑

},
methods: {
  
},            
}
</script>
<style lang='scss' scoped>
</style>